export default function UiMosque({ fillColor }) {
  return (
    <svg
      fill="none"
      height="24"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g stroke={fillColor} strokeLinecap="round" strokeWidth="1.5">
        <path
          d="m5.46474 13c-3.1165-3.5 2.19974-5.25 3.53526-7 1.3357 1.75 6.652 3.5 3.5354 7z"
          strokeLinejoin="round"
        />
        <path
          d="m17.7631 7c-2.0591-2.5.6045-3.75 1.4869-5 .8825 1.25 3.546 2.5 1.4869 5z"
          strokeLinejoin="round"
        />
        <path d="m10 3.65685c-.21201.21202-.50491.34315-.82843.34315-.64704 0-1.17157-.52453-1.17157-1.17157 0-.32352.13113-.61642.34315-.82843" />
        <g strokeLinejoin="round">
          <path d="m9 4v1 1" />
          <path d="m17 17v5h-12.85714c-1.01016 0-1.51523 0-1.82905-.2929-.31381-.2929-.31381-.7643-.31381-1.7071v-3c0-1.8856 0-2.8284.62763-3.4142s1.63778-.5858 3.65808-.5858h6.42859c2.0203 0 3.0304 0 3.6581.5858.6276.5858.6276 1.5286.6276 3.4142z" />
          <path d="m15 22h2.6871c2.1507 0 3.226 0 3.8462-.658s.5132-1.6853.2992-3.74l-1.1042-10.602h-3.1245l-.9721 6.5" />
          <path d="m7.00009 22v-2c-.0173-3 2.49991-4 2.49991-4s2.5172 1 2.4999 4v2" />
        </g>
      </g>
    </svg>
  );
}
